<template lang="html">
  <div class="l-container">
    <div
      class="l-user-item"
      :class="{ selected: isActiveSubMenu(item) }"
      v-for="(item, index) in options"
      :key="index"
      @click="handleTabClick(item, index)"
      v-show="isShow(item)"
    >
      <i :class="item.icon" class="iconfont l-user-item-icon"></i>
      <span class="l-user-item-text">{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        {
          icon: 'icon-shijian1',
          text: this.$t('sysmanagement.time-config'),
          routeName: 'sysmanagement-season-adjust',
          children: [2,3]
        },
        {
          icon: '',
          text: this.$t('sysmanagement.season-adjust'),
          routeName: 'sysmanagement-season-adjust',
          parent: 1
        },
        {
          icon: '',
          text: this.$t('sysmanagement.month-adjust'),
          routeName: 'sysmanagement-month-adjust',
          parent: 1
        },
        {
          icon: 'icon-gonggao',
          text: this.$t('sysmanagement.system-notice'),
          routeName: 'sysmanagement-system-notice'
        },
        {
          icon: 'icon-yonghuquanxian',
          text: this.$t('sysmanagement.privilege'),
          routeName: 'sysmanagement-privilege'
        },
        {
          icon: 'icon-caidan',
          text: this.$t('sysmanagement.menu'),
          routeName: 'sysmanagement-menu'
        },
        {
          icon: 'icon-jiaoseguanli',
          text: this.$t('sysmanagement.role'),
          routeName: 'sysmanagement-role'
        },
        {
          icon: 'icon-shujuzidian',
          text: this.$t('sysmanagement.dict-list'),
          routeName: 'sysmanagement-dict-list'
        },
        {
          icon: 'icon-xiaoxi1',
          text: this.$t('sysmanagement.email-template'),
          routeName: 'sysmanagement-email-template'
        }
      ],
      showOther: false
    };
  },
  methods: {
    handleTabClick(item, index) {
      if (this.$route.name != item.routeName) {
        this.$router.push({
          name: item.routeName
        });
      }
    },
    isActiveSubMenu(subMenu) {
      if(subMenu.children) {
        for (const child of subMenu.children) {
          if(this.$route.name == this.options[child-1].routeName){
            return true;
          }
        }
        return false;
      }
    
      return this.$route.name == subMenu.routeName;
    },
    isShow(subMenu) {
      if(subMenu.parent){
        return this.isActiveSubMenu(this.options[subMenu.parent-1]);
      }
      else{
        return true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.l-container {
  color: @mainFontColor;
  .l-user-item {
    width: 100%;
    height: 40px;
    padding: 0px 22px;
    display: flex;
    align-items: center;

    &-icon {
      font-size: 16px;
      width: 16px;
    }

    &-text {
      margin-left: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      display: inline-block;
    }

    &:hover {
      color: #0066CC;
      cursor: pointer;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.selected {
  color: #0066CC;
}
</style>



// WEBPACK FOOTER //
// LeftBar.vue?3eec5eb7